import { render, staticRenderFns } from "./Deny.vue?vue&type=template&id=73adda5c&scoped=true"
var script = {}
import style0 from "./Deny.vue?vue&type=style&index=0&id=73adda5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73adda5c",
  null
  
)

export default component.exports